const siteDetails = [
  {
    siteId: 'Carroll',
    departmentId: null,
    teamsConfig: {
      quality: {
        teamsAddress: '7400b9af-3834-474e-ba1e-ced3fc5e54d7',
        channelId: '19:ef6872f0c2e84cb0a0471dd653d2c5eb@thread.tacv2',
      },
      maintenance: {
        teamsAddress: 'a4fc1cf1-a170-4d00-bca2-01bd2bef2276',
        channelId: '19:277aaddfcdac4a6f9fb6bf8f4127ed2a@thread.skype',
      },
    },
  },
  {
    siteId: 'Macomb',
    departmentId: null,
    teamsConfig: {
      quality: {
        teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
        channelId: '19:4c18e42e8806499796d8819858305bce@thread.tacv2',
      },
      maintenance: {
        teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
        channelId: '19:79116e6ba2024bc5a49cb29fcca3acef@thread.tacv2',
      },
    },
  },
  {
    siteId: 'Murray',
    departmentId: null,
    teamsConfig: {
      quality: {
        teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
        channelId: '19:014d0149edcd4b74b3d397dcd9fb0c52@thread.tacv2',
      },
      maintenance: {
        teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
        channelId: '19:ba51bb8bf3c04022b36cd09bd7960c91@thread.tacv2',
      },
    },
  },
  {
    siteId: 'Shenandoah',
    departmentId: null,
    teamsConfig: {
      quality: {
        teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
        channelId: '19:eae35f841d0b4f23b7f4192463b99219@thread.tacv2',
      },
      maintenance: {
        teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
        channelId: '19:a828d41bde6e4efa9f9125cd45121d27@thread.tacv2',
      },
    },
  },
  {
    siteId: 'Sioux Center',
    departmentId: null,
    teamsConfig: {
      quality: {
        teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
        channelId: '19:072ec97eaf6d4707adf84961fb318367@thread.tacv2',
      },
      maintenance: {
        teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
        channelId: '19:83832e6f38f7486b90863d200ae47f46@thread.tacv2',
      },
    },
  },

  {
    siteId: 'PellaMfg',
    departmentId: 'Accessory',
    teamsConfig: {
      quality: {
        teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
        channelId: '19:bdcca5c386fe440aa269e6568020ce93@thread.tacv2',
      },
      maintenance: {
        teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
        channelId: '19:af77fc49b3094d2787becd6fb2573673@thread.tacv2',
      },
    },
  },
  {
    siteId: 'PellaMfg',
    departmentId: 'Service Parts',
    teamsConfig: {
      quality: {
        teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
        channelId: '19:4f37a131ad8f457f823103f4e010b03b@thread.tacv2',
      },
      maintenance: {
        teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
        channelId: '19:f534c5a16ad64e3a863f49fe567d324f@thread.tacv2',
      },
    },
  },
  {
    siteId: 'PellaMfg',
    departmentId: 'Windows',
    teamsConfig: {
      quality: {
        teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
        channelId: '19:17b060be102b41bda0bc453892d3f570@thread.tacv2',
      },
      maintenance: {
        teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
        channelId: '19:427dd867324340e385cfc0708b92f82a@thread.tacv2',
      },
    },
  },
  {
    siteId: 'PellaMfg',
    departmentId: 'Door',
    teamsConfig: {
      quality: {
        teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
        channelId: '19:79ef27f6fa6345a7916fb4f0ee117144@thread.tacv2',
      },
      maintenance: {
        teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
        channelId: '19:caf637347f9e4345ab6e51415f5dd397@thread.tacv2',
      },
    },
  },
  {
    siteId: 'PellaMfg',
    departmentId: 'Metal',
    teamsConfig: {
      quality: {
        teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
        channelId: '19:26a4e8215b3a43258c4d0ed17c694793@thread.tacv2',
      },
      maintenance: {
        teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
        channelId: '19:30f51d60635a423a8b3caa9f067b581f@thread.tacv2',
      },
    },
  },
  {
    siteId: 'PellaMfg',
    departmentId: 'Lumber',
    teamsConfig: {
      quality: {
        teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
        channelId: '19:2e4e329a47cf4d41b9f3a79a4c60f618@thread.tacv2',
      },
      maintenance: {
        teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
        channelId: '19:cc26ba2164cd49d1b17d6797cf6ff184@thread.tacv2',
      },
    },
  },
  {
    siteId: 'PellaMfg',
    departmentId: 'DVA',
    teamsConfig: {
      quality: {
        teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
        channelId: '19:e3dd95ce29dc4cd4bcfc51de608c93b6@thread.tacv2',
      },
      maintenance: {
        teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
        channelId: '19:ce1c6224477f4e92a030c4d4e568d97d@thread.tacv2',
      },
    },
  },
  {
    siteId: 'Reidsville',
    departmentId: null,
    teamsConfig: {
      quality: {
        teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
        channelId: '19:4055034adb97449f9f87f0bc85f195a1@thread.tacv2',
      },
      maintenance: {
        teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
        channelId: '19:4cd265d2c8e540088072de19e04f2229@thread.tacv2',
      },
    },
  },
  {
    siteId: 'Gettysburg',
    departmentId: null,
    teamsConfig: {
      quality: {
        teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
        channelId: '19:21124c1a5e714445b551ecc0424a5257@thread.tacv2',
      },
      maintenance: {
        teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
        channelId: '19:f70c9f142a984c18ac258bee00e03c2f@thread.tacv2',
      },
    },
  },
  {
    siteId: 'Portland',
    departmentId: null,
    teamsConfig: {
      quality: {
        teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
        channelId: '19:8a94473b0c0745a7aa7962521ad5eefc@thread.tacv2',
      },
      maintenance: {
        teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
        channelId: '19:c2d5c53652494c63a3a10934f88d04d4@thread.tacv2',
      },
    },
  },
  {
    siteId: 'Troy',
    departmentId: null,
    teamsConfig: {
      quality: {
        teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
        channelId: '19:e186e3a5d17242f98e1237f3bc5dcd1f@thread.tacv2',
      },
      maintenance: {
        teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
        channelId: '19:3bd16826c4cf47fa83b6ee9c110a8d87@thread.tacv2',
      },
    },
  },
  {
    siteId: 'PellaPltSrv',
    departmentId: 'Central/Sawdust',
    teamsConfig: {
      quality: {
        teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
        channelId: '19:c05a88b2ae564e3eb517e84d624cd5d4@thread.tacv2',
      },
      maintenance: {
        teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
        channelId: '19:c7379c5e8a554b4ba3efdf08e3803076@thread.tacv2',
      },
    },
  },
  {
    siteId: 'PellaPltSrv',
    departmentId: 'Custodial',
    teamsConfig: {
      quality: {
        teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
        channelId: '19:993e3179aa9947488c778541ed77c82d@thread.tacv2',
      },
      maintenance: {
        teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
        channelId: '19:993e3179aa9947488c778541ed77c82d@thread.tacv2',
      },
    },
  },
  {
    siteId: 'PellaPltSrv',
    departmentId: 'Facilities',
    teamsConfig: {
      quality: {
        teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
        channelId: '19:c05a88b2ae564e3eb517e84d624cd5d4@thread.tacv2',
      },
      maintenance: {
        teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
        channelId: '19:837c742a78da42f89018014e4a9afbc6@thread.tacv2',
      },
    },
  },
  {
    siteId: 'PellaPltSrv',
    departmentId: 'Grounds',
    teamsConfig: {
      quality: {
        teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
        channelId: '19:c05a88b2ae564e3eb517e84d624cd5d4@thread.tacv2',
      },
      maintenance: {
        teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
        channelId: '19:10fc667145a04b2a94f3b25c1f73e3d4@thread.tacv2',
      },
    },
  },
  {
    siteId: 'PellaPltSrv',
    departmentId: 'HVAC',
    teamsConfig: {
      quality: {
        teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
        channelId: '19:c05a88b2ae564e3eb517e84d624cd5d4@thread.tacv2',
      },
      maintenance: {
        teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
        channelId: '19:20307edf4255410c876586e6580a072f@thread.tacv2',
      },
    },
  },
  {
    siteId: 'PellaPltSrv',
    departmentId: 'MES Maintenance',
    teamsConfig: {
      quality: {
        teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
        channelId: '19:c05a88b2ae564e3eb517e84d624cd5d4@thread.tacv2',
      },
      maintenance: {
        teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
        channelId: '19:d8dc7a57c87646df984ffcb07e065926@thread.tacv2',
      },
    },
  },
  {
    siteId: 'PellaPltSrv',
    departmentId: 'Truck Shop',
    teamsConfig: {
      quality: {
        teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
        channelId: '19:c05a88b2ae564e3eb517e84d624cd5d4@thread.tacv2',
      },
      maintenance: {
        teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
        channelId: '19:28d076deef764c239c32f0ba071e2bbc@thread.tacv2',
      },
    },
  },
  {
    siteId: 'Burris',
    departmentId: null,
    teamsConfig: {
      quality: {
        teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
        channelId: '19:0dfbfb0b327c4ae79c0a55530344ade2@thread.tacv2',
      },
      maintenance: {
        teamsAddress: 'ab6a42b1-7018-4f05-8e21-2fcc291f0f07',
        channelId: '19:deeaecedb68b491fa3f2e1a16e68655b@thread.tacv2',
      },
    },
  },
  {
    siteId: 'CWS',
    departmentId: 'CWOCA',
    teamsConfig: {
      quality: {
        teamsAddress: null,
        channelId: null,
      },
      maintenance: {
        teamsAddress: 'b6814d50-0b7e-4ab0-9d7e-69a702cda22e',
        channelId: '19:33750e540e0c4fb5b4f8933e0fc7134f@thread.tacv2',
      },
    },
  },
  {
    siteId: 'CWS',
    departmentId: 'CWJAC',
    teamsConfig: {
      quality: {
        teamsAddress: null,
        channelId: null,
      },
      maintenance: {
        teamsAddress: 'b6814d50-0b7e-4ab0-9d7e-69a702cda22e',
        channelId: '19:3341cf4c5e934aa59c04d811f9841733@thread.tacv2',
      },
    },
  },
  {
    siteId: 'Medley',
    departmentId: null,
    teamsConfig: {
      quality: {
        teamsAddress: null,
        channelId: null,
      },
      maintenance: {
        teamsAddress: 'b6814d50-0b7e-4ab0-9d7e-69a702cda22e',
        channelId: '19:a10b3d496b5b4d018b7fb2744d491533@thread.tacv2',
      },
    },
  },
  {
    siteId: 'Avanti',
    departmentId: 'AVAZM',
    teamsConfig: {
      quality: {
        teamsAddress: null,
        channelId: null,
      },
      maintenance: {
        teamsAddress: '282477d1-38bd-4d73-aba3-8ad31b6e8e0c',
        channelId: '19:vHFhrcHrcMFPpNuX898KvDGzilrDBSoxQ_oUQwAJ1IA1@thread.tacv2',
      },
    },
  },
];
export default siteDetails;
